import { useQuery } from '@tanstack/react-query';
import { bff } from 'shared/api';
import {
  ResourceNameListReply,
  ResourceNameListRequest,
} from 'shared/types/protoc-gen/bffbillsystem';
import { QUERY_KEYS } from 'shared/types/react-query';

export type UseGetResourceParams = Omit<ResourceNameListRequest, 'nameRegex'> &
  Partial<Pick<ResourceNameListRequest, 'nameRegex'>>;

const useGetResourceList = (params: UseGetResourceParams) => {
  const kind = params.kind !== 'ALL' ? params.kind : '';
  const type = params.type !== 'ALL' ? params.type : '';
  const namespace = params.namespace !== 'ALL' ? params.namespace : '';
  const subresource = params.subresource !== 'ALL' ? params.subresource : '';

  const payload: UseGetResourceParams = {
    ...params,
    kind,
    type,
    namespace,
    subresource,
  };

  return useQuery({
    queryKey: [QUERY_KEYS.ADMIN_COST_RESOURCES, kind, type, namespace, subresource],
    queryFn: async () => {
      const res = await bff.get<ResourceNameListReply>('/bff/cost/resource_name_list', {
        params: payload,
      });

      return res.data;
    },
  });
};

export default useGetResourceList;
